// extracted by mini-css-extract-plugin
module.exports = {"hidden":"TableHead_hidden__1o1bF"};